import { supabase } from '@/lib/supabase';
import { Auth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { MODE_DEV } from '@/constants';
import { Logo } from '@/components/ui/icons';
import siteConfig from '@/config';
import { Provider } from '@supabase/supabase-js';

const SignIn = () => {
  // กำหนด providers จาก siteConfig
  const providers = [] as Provider[];
  if (siteConfig.auth.github) providers.push('github');
  if (siteConfig.auth.google) providers.push('google');

  // แยก class สำหรับแต่ละปุ่ม
  const forgotPasswordClass = !siteConfig.auth.password.forgot ? 'hide-forgot-password' : '';
  const signUpClass = !siteConfig.auth.password.signUp ? 'hide-sign-up' : '';

  return (
    <div className="bg-gray-50">
      <div className="relative isolate h-full min-h-screen bg-gray-50 text-gray-900">
        <svg
          aria-hidden="true"
          className="absolute inset-0 -z-10 h-full w-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
        >
          <defs>
            <pattern
              x="50%"
              y={-1}
              id="0787a7c5-978c-4f66-83c7-11c213f99cb7"
              width={200}
              height={200}
              patternUnits="userSpaceOnUse"
            >
              <path d="M.5 200V.5H200" fill="none" />
            </pattern>
          </defs>
          <rect
            fill="url(#0787a7c5-978c-4f66-83c7-11c213f99cb7)"
            width="100%"
            height="100%"
            strokeWidth={0}
          />
        </svg>

        <div className="">
          <div className="pt-4 sm:pt-12">
            <Logo className="mx-auto h-10 w-10" />
            <p className="pt-8 text-center text-lg font-semibold md:pt-12 md:text-2xl">
              Sign in to your account
            </p>
          </div>
          <div className="gap-4 pt-8 md:pt-12">
            <div className="flex justify-center">
              <div className="w-full max-w-[480px] rounded-md bg-white p-8 shadow sm:rounded-lg sm:px-12">
                <Auth
                  supabaseClient={supabase}
                  appearance={{
                    theme: ThemeSupa,
                    variables: {
                      default: {
                        colors: {
                          brand: '#13171b',
                          brandAccent: 'black',
                        },
                      },
                    },
                    className: {
                      anchor: `${forgotPasswordClass} ${signUpClass}`
                    },
                  }}
                  providers={providers}
                  // view={siteConfig.auth.email ? undefined : 'magic_link'}
                  queryParams={{
                    prompt: 'select_account',
                  }}
                  {...(MODE_DEV && { redirectTo: window.location.origin })}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SignIn;
